module.exports = __webpack_public_path__ + "static/media/reposicion-tarjeta.d91b3d33.svg";